var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMemberPriceStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8666 41.5998C33.5131 41.5998 41.3332 33.7797 41.3332 24.1332C41.3332 14.4866 33.5131 6.6665 23.8666 6.6665C14.22 6.6665 6.3999 14.4866 6.3999 24.1332C6.3999 33.7797 14.22 41.5998 23.8666 41.5998Z",
    fill: "#FDA9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2067 31.1943C21.8844 31.1943 21.6219 30.9336 21.6219 30.6137V27.6673C21.6219 26.9978 21.0734 26.4547 20.4006 26.4547H17.5759C17.2537 26.4547 16.9912 26.194 16.9912 25.8741V22.394C16.9912 22.074 17.2537 21.8134 17.5759 21.8134H20.4006C21.0749 21.8134 21.6219 21.2688 21.6219 20.6008V17.6528C21.6219 17.3329 21.8844 17.0723 22.2067 17.0723H25.7119C26.0342 17.0723 26.2967 17.3329 26.2967 17.6528V20.5993C26.2967 21.2688 26.8452 21.8118 27.518 21.8118H30.3427C30.6649 21.8118 30.9274 22.0725 30.9274 22.3924V25.8726C30.9274 26.1925 30.6649 26.4531 30.3427 26.4531H27.518C26.8437 26.4531 26.2967 26.9978 26.2967 27.6657V30.6121C26.2967 30.9321 26.0342 31.1927 25.7119 31.1927H22.2067V31.1943ZM22.7442 21.7135C22.0699 21.7135 21.5229 22.2582 21.5229 22.9261V25.3404C21.5229 26.0099 22.0715 26.553 22.7442 26.553H25.1759C25.8503 26.553 26.3973 26.0083 26.3973 25.3404V22.9261C26.3973 22.2566 25.8487 21.7135 25.1759 21.7135H22.7442Z",
    fill: "#E52326"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberPriceStar);
export default __webpack_public_path__ + "static/media/MemberPriceStar.a2a256f078f970d0bb297e5d51ef5e66.svg";
export { ForwardRef as ReactComponent };